import React, { useContext, useEffect } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { Button, PlusIcon } from '@motorway/mw-highway-code';
import { VARIANT } from '@motorway/mw-highway-code/enums';

import { UserContext } from 'Context/user';
import { VehicleLookupContext } from 'Context/vehicleLookup';

import { HOMEPAGE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsHomePage';

import { Content } from 'LegacySBCRA/Content/Content';

import { VehicleImage } from '../../../../../components/misc/VehicleImage/VehicleImage';
import { RoundedSection } from '../../../common/RoundedSection/RoundedSection';
import LocalTexts from '../../HomepageTexts.json';
import { VehicleCardReturningUser } from '../VehicleCardReturningUser/VehicleCardReturningUser';

import { HeroContent } from './SubComponents/HeroContent/HeroContent';
import { TrustPilotHero } from './SubComponents/HomepageVRM/TrustPilotHero';

import styles from './HeroReturningUser.module.scss';

const LocalT = new MDText(LocalTexts);

const TEXTS = {
  subTitle: LocalT.translate('hero.subTitleReturningUser.laptop') as string,
  subTitleMobile: LocalT.translate('hero.subTitleReturningUser.mobile', {
    asterisk: (<sup className={styles.asterisk}>*</sup>),
  }) as string,
  title: (username: string) => LocalT.translate('hero.titleReturningUser', {
    name: (
      <>
        {username ? ',' : ''}
        <br />
        {username}
      </>
    ),
  }) as string,
};

export const HeroReturningUser = () => {
  const { userState: user = { firstName: '' } } = useContext(UserContext);
  const { vehicleLookupActions, vehicleLookupState: vehicle } = useContext(VehicleLookupContext);

  useEffect(() => {
    const label = JSON.stringify({
      dp_enquiry_id: vehicle?.enquiry?.dpEnquiryId,
      plt_enquiry_id: vehicle?.enquiry?.id,
      plt_valuation_id: vehicle?.enquiry?.valuation?.id,
    });

    HOMEPAGE_SNOW_PLOW_EVENTS.HERO_RETURN_USER_LOADED(label);
  }, []);

  const handleAddVehicle = () => {
    HOMEPAGE_SNOW_PLOW_EVENTS.HERO_RETURN_USER_ADD_VEHICLE_CLICKED();
    vehicleLookupActions.remove();
  };

  return (
    <RoundedSection withBottomLedge className={styles.wrapper} dataAttributes={{ 'data-section': 'hero-returning-user' }} theme="primary-yellow">
      <Content
        className={styles.content}
        wrapper={{ className: cx(styles.component) }}
      >
        <div className={styles.headingBlock}>
          <HeroContent
            className={styles.heading}
            customTitle={(
              <>
                <span className={styles.descriptionLaptop}>
                  {TEXTS.subTitle}
                </span>
                <span className={styles.descriptionMobile}>
                  {TEXTS.subTitleMobile}
                </span>
              </>
            )}
            subTitle={TEXTS.subTitle}
            title={TEXTS.title(user?.firstName ?? '')}
            titleSecondary={null}
          />

          <div className={styles.trustpilotWrapper}>
            <TrustPilotHero />
          </div>
        </div>

        <div className={styles.vehicleInfoBlock}>
          <VehicleCardReturningUser />
          <div className={styles.button}>
            <Button
              fullWidth
              reverse
              icon={PlusIcon}
              label={`${LocalT.translate('hero.addAnotherVehicle')}`}
              onClick={handleAddVehicle}
              variant={VARIANT.TERTIARY}
            />
          </div>
          <VehicleImage className={styles.image} name="hero_bmw_blue" />
        </div>
      </Content>
    </RoundedSection>
  );
};
